var _defs, _rect, _circle, _circle2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentEngagementRoutesDarkBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 1000,
    viewBox: "0 0 1600 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Dark luminous consulting background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A69C9",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A69C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41157",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A41157",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1000,
    fill: "#020716"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 300,
    r: 440,
    fill: "url(#a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1350,
    cy: 820,
    r: 390,
    fill: "url(#b)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#2871B3",
    strokeOpacity: 0.28
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 450,
    r: 220
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 450,
    r: 310
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40 860 1390 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120 0c-120 320 10 610 330 840"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#74BDFF",
    fillOpacity: 0.62
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 160,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1190,
    cy: 180,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1470,
    cy: 650,
    r: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentEngagementRoutesDarkBackground);
export default __webpack_public_path__ + "static/media/custom-development-engagement-routes-dark-background.80c0b1b1a4e451e38d59c9e0998a0b08.svg";
export { ForwardRef as ReactComponent };